@if (wordCount > 6) {
    <span (click)="gotoPage()" [class.bg-lighter-green]="clickable" [innerHTML]="label()">
    </span>

} @else {
    <span (click)="gotoPage()" [class.bg-lighter-green]="clickable"
        [stickyPopover]="popContent"
        popoverClass="bd-green-popover"
    >
        <span>
            {{words}}
            <span class="last-word">
                {{lastWord}}
                <ng-icon [name]="icon" [size]="size()" [class.baseline]="size() !== '14px'"></ng-icon>
            </span>
        </span>
    </span>
}

<ng-template #popContent>
    <div class="fw-bolder">{{ titleDescription }} {{ popoverContent }}</div>
    <button type="button" class="btn btn-bankruptcydata" (click)="followUnfollow()">{{title}}</button>
</ng-template>